var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "audience"
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-touxiang"
  }), _c('span', {
    staticClass: "audienceTitle"
  }, [_vm._v(_vm._s(_vm.$t('common.audience')))]), _c('span', {
    staticClass: "audienceTotal"
  }, [_vm._v("(" + _vm._s(_vm.audienceList.length) + ")")])]), _c('el-divider'), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tipsTitle"
  }, [_vm._v(_vm._s(_vm.$t('common.audience')) + ":")]), _c('div', {
    staticClass: "tipsContent"
  }, [_vm._v(_vm._s(_vm.$t('common.audienceTips1')))]), _c('div', {
    staticClass: "tipsContent"
  }, [_vm._v(_vm._s(_vm.$t('common.audienceTips2')))]), _c('div', {
    staticClass: "tipsContent"
  }, [_vm._v(_vm._s(_vm.$t('common.audienceTips3')))])])], 1), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "listTitle"
  }, [_c('span', {
    staticClass: "titleCommon number"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.num')))]), _c('span', {
    staticClass: "titleCommon name"
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.name')))]), _c('span', {
    staticClass: "titleCommon corporation"
  }, [_vm._v(_vm._s(_vm.$t('startNewParty.corporation')))]), _c('span', {
    staticClass: "titleCommon operation"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.handQueueParOperation')))])]), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadList,
      expression: "loadList"
    }],
    staticClass: "listContent scrollbar"
  }, _vm._l(_vm.audienceList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "listLi",
      class: {
        red: _vm.PrivateInfo.rtilCode == item.rtilCode || _vm.PrivateInfo.crewRtilCode == item.rtilCode
      }
    }, [_c('span', {
      staticClass: "liCommon"
    }, [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(Number(index) + 1))])]), _c('span', {
      staticClass: "liCommon name",
      attrs: {
        "title": item.nickName
      }
    }, [_vm._v(_vm._s(item.nickName + (item.rtilCode == _vm.userInfo.rtilCode ? `(${_vm.$t('kioskHost.me')})` : '')) + _vm._s(_vm.tagNameInfo[item.rtilCode] ? ` / ${_vm.tagNameInfo[item.rtilCode]}` : ''))]), _c('span', {
      staticClass: "liCommon corporation",
      attrs: {
        "title": item.organization
      }
    }, [_vm._v(_vm._s(item.organization))]), _c('span', {
      staticClass: "liCommon configIcon pointer"
    }, [_vm.State.batchMoveParticipate && item.rtilCode != _vm.userInfo.rtilCode ? _c('div', {
      staticClass: "checkBox"
    }, [_c('el-checkbox', {
      on: {
        "change": val => {
          _vm.moveParty(val, item.rtilCode);
        }
      },
      model: {
        value: _vm.movePips[item.rtilCode],
        callback: function ($$v) {
          _vm.$set(_vm.movePips, item.rtilCode, $$v);
        },
        expression: "movePips[item.rtilCode]"
      }
    })], 1) : _vm._e(), !_vm.State.batchMoveParticipate ? _c('operate-button', {
      attrs: {
        "btnList": _vm.participantsOperateList[item.rtilCode],
        "userInfo": _vm.userInfo,
        "singChannel": {
          id: item.rtilCode,
          channel: _vm.userInfo.realPartyCode
        },
        "nickName": item.nickName,
        "organization": item.organization,
        "currentRole": "audience"
      },
      on: {
        "callback": _vm.callback
      }
    }) : _vm._e()], 1)]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };